<template>
    <div class="subscribe-page login-page ac">
		<Header></Header>
    <img width="320" src="../../static/images/login-img.png" />
		<div class="content al mt100">
      <div class="fs50">{{$t('regTips1')}}</div>
      <div class="">{{$t('regTips2')}}</div>
      <div class="cr5667fd fs33 mt30">{{$t('regTips3')}}</div>
      <div class="input-text fw7 mt30">{{$t('regTips4')}}</div>
      <div class="phone-t por">
        <span class="code-num">09</span>
        <input class="input-block" v-model="mobile" type="" value="dmwdovWn4aLDq/Q=" name="mobile" :placeholder="$t('phone_number')">
      </div>

			<!--<input class="input-block mt30" v-model="passwd" type="password" name="passwd" placeholder="Inster Your password">-->
			<div class="unsubscribe ">
				<button class="button active  fs40 btn-block mt30" @click="_loginAction">{{$t('Login')}}</button>
			</div>
      <div class="ac mt50">
      	<router-link :to="{path:'/faq'}">
      		<span class="cr5667fd mt10" style="line-height: 22px;text-decoration: underline;">{{$t('FAQs')}} </span>
      	</router-link>
      	<router-link :to="{path:'/termsAndCondition'}">
      		<span class="cr5667fd ml30 mt10" style="text-decoration: underline;">{{$t('T_C')}}</span>
      	</router-link>
      </div>
		</div>
		<Dialog ref="saveDialog" :callback="_loginAction2" title="" type="alert" :btnText="$t('Yes')" cancelText="">
            <div slot="mdBox" >
                <div class="ac fs33">
					<div class="radio-div">
						<span><input class="radio" v-model="type" type="radio" name="radios" value="day" checked ><label style="margin-right:10px;">{{$t('day')}}</label></span>
						<span><input class="radio" v-model="type" type="radio" name="radios" value="week" checked><label>{{$t('week')}}</label></span>
					</div>
				</div>
            </div>
        </Dialog>
		<Dialog ref="saveDialog2" :callback="tips2Modal" title="" type="alert" :btnText="$t('Yes')" cancelText="">
            <div slot="mdBox" >
                <div class="ac fs33">
					<div class="radio-div">
						{{$t('tips2')}}
					</div>
				</div>
            </div>
        </Dialog>
        <div class="modal login-modal" v-if="isShow2">
          <div class="modal-bg"></div>
          <div class="modal-content modal-content2">
            <img :src="dataPopup.image" />
            <div class="close ac" @click="getClose">x</div>
          </div>

        </div>
	</div>
</template>
<script>
import Header from '../components/HeaderLogin'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
		Dialog
    },
    data() {
        return {
			mobile:'',
			passwd:'123456',
			type:'day',
			is_register:'',
			isShow:false,
      isShow2:false,
      dataPopup:null,

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;

    },
	created(){
		//dmwdovWn4aLDq/Q=
		//var url = 'http://auth.studygo.asia/'
		//window.location.href = url
		if(localStorage.getItem('mobile1')){
			this.mobile = localStorage.getItem('mobile1')
		}else if(this.$route.query.msisdn){
			let str = this.$route.query.msisdn
			str.replace(/\s+/g, '')
			str.replace(/\s+/g, '+')
			this.mobile = str
		}
		this._loginAction()
		this.getItem();
	},
    methods: {
		getItem() {
			if (!localStorage.getItem('setTime_v2') || (localStorage.getItem('setTime_v2') &&
				Date.parse(new Date()) - localStorage.getItem('setTime_v2') >= 86400000)) {//86400000 24h
				localStorage.removeItem('setTime_v2');
				localStorage.setItem('setTime_v2', Date.parse(new Date()));
				this.getapiPopup();
			}
	  },
      getapiPopup(){
        let that = this
        let data = {
          type:'login'
        }
        that.$api.post('/api/user/fast_login',data,r =>{
        	that.$parent.returnCode(r,function(){
           // r.data = []
            that.dataPopup = r.data
            console.log(that.dataPopup)
            if(that.getapiPopup!==null){
              that.isShow2 = true
            }
        	})
        })

      },
      getClose(){
        this.isShow2 = false
      },
		_loginAction(){
			let that = this;
			if(that.mobile==''){
				that.$utils.alertText(that.$t('tips'),60)
				return;
			}
			that.$parent.loadModal(true);
			var channelId  = this.$route.query.channelId
			var data = {mobile: '09'+that.mobile,channelId:channelId}
			that.$api.post('/login/check',data,r =>{
				that.$parent.returnCode(r,function(){
					that.is_register = r.data.is_register
					if(that.is_register){
            //验证码
            // that.$router.push({path:'/code',query: {mobile:that.mobile}})
            that.$router.push('/');
            localStorage.setItem('token',r.data.token)
            localStorage.setItem('uuid',r.data.uuid)
            localStorage.setItem('mobile',r.data.mobile)
					}else{
					  if (r.data.channelId){
					    that._loginAction2();
            }else {
              that.$refs.saveDialog.showMaskFun();
            }
					}
					that.$parent.loadModal(false);
				})
			})
		},
		tips2Modal(){
			this.$refs.saveDialog2.closeMask();
		},
		_loginAction2(type){
			let that =this;
			//that.type = type
			if(that.mobile==''){
				that.$utils.alertText(that.$t('tips'),60)
				return;
			}
			that.$parent.loadModal(true);
      var channelId  = this.$route.query.channelId
      var tracker  = this.$route.query.tracker
			var data = {mobile: '09'+that.mobile, password: this.passwd,type:that.type,channelId:channelId,tracker:tracker}
			that.$api.post('/login/login',data,r =>{
				console.log(r.code==401)
				if(r.code==401){
					that.$refs.saveDialog2.showMaskFun();
				}
				that.$parent.returnCode(r,function(){
					that.$refs.saveDialog.closeMask();
					that.$router.push('/');
					that.$parent.loadModal(false);
					localStorage.setItem('token',r.data.token)
					localStorage.setItem('uuid',r.data.uuid)
					localStorage.setItem('mobile',r.data.mobile)
        });

			})
		}
	}
}
</script>
<style>
  .code-num{position:absolute;left: 15px;top: 2px;height: 86px;line-height: 86px;font-size: 30px;padding: 0 10px;font-weight:700;}
	.input-block{border: none;color:#364356;
    background: none;
    border-bottom: 1px solid #8bb0d0;height: 90px;
    width: 100%;
    padding: 0 20px;
    font-size: 30px;padding-left: 70px;}
	.radio-div{margin:40px 0 20px;}
	.radio{width:30px;height:30px;vertical-align: middle;margin: 0 10px 0 0;}
  .modal-content2{position:absolute;top:50%;left:50%;margin-top:-10px;border-radius:8px;margin-left: -45%;width: 90%;}
  .modal-content2 img{border-radius:20px;width:100%;}
  .close{background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 80px;
    height: 80px;
    font-size: 47px;
    margin: 30px auto 0;
    border-radius: 100px;}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue